import { useMemo } from 'react';

import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { adjustRangeForDayGranularity } from '@cast/split-me/utils';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);

import { useInventoryWorkloadsTimeRangeSelection } from '../../../../_hooks/useInventoryWorkloadsTimeRangeSelection';
import { getComputeGranularity } from '../_utils/getComputeGranularity';

export const useComputeAdjustedDateRange = () => {
  const { getRange, timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const range = getRange();

  return useMemo(() => {
    const currentDateRange: [Dayjs, Dayjs] = [
      dayjs.utc(range.from),
      dayjs.utc(range.to),
    ];

    const { unit, stepSeconds } = getComputeGranularity(currentDateRange);

    const adjustedDateRange: [Dayjs, Dayjs] =
      unit === 'day'
        ? adjustRangeForDayGranularity(currentDateRange, timeZone, false)
        : (() => {
            const start = currentDateRange[0].startOf('hour');
            let end = currentDateRange[1].startOf('hour');

            if (end.isSameOrBefore(start)) {
              end = end.add(1, 'hour');
            }

            return [start, end];
          })();

    return {
      currentDateRange,
      adjustedDateRange,
      unit,
      stepSeconds,
      timeZone,
    };
  }, [range.from, range.to, timeZone]);
};
